<div class="w-100 font-16">
    <div class="row ">
        <div class="col-3">
            <i class="mdi mdi-account text-primary mr-1"></i><strong style="font-size:17px">Patient Name:</strong>&nbsp;
            <span *ngIf="appointment && appointment.patientName" [textContent]="appointment.patientName"></span>
        </div>
        <div class="col-3">
            <i class="text-primary mr-1"></i><strong style="font-size:17px">UMR No.:</strong>&nbsp;
            <span *ngIf="appointment && appointment.umrNo" [textContent]="appointment.umrNo"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.patientGender =='F'">
            <i class="mdi mdi-account text-primary mr-1"></i><strong style="font-size:17px">Husband Name:</strong>&nbsp;
            <span [textContent]="husbandName"></span>
        </div>
        <div class="col-3" *ngIf="appointment && appointment.patientGender =='M'">
            <i class="mdi mdi-account text-primary mr-1"></i><strong style="font-size:17px">Wife Name:</strong>&nbsp;
            <span [textContent]="wifeName"></span>
        </div>
    </div>
   <!-- <div class="row d-flex font-weight-medium align-items-baseline">
      
       
       
    </div>-->
    
</div>